<script>
	import { createEventDispatcher } from 'svelte'

	const dispatch = createEventDispatcher()

	export let input

	export let value
	export let max
	export let show_options = false
	export let range = [
		1, 2, 3, 4, 5, 6, 7, 8, 9,
	]
	export let parent_value = value

	$: {
		if (value) {
			show_options = show_options && value < 10

			let new_value = Math.max((max === -1 ? value : Math.min(value, max)), 1)
			value = new_value
		}
	}

	function text() {
		value = 10
		if (input) {
			input.focus()
		}
	}

	let keep_open = false
	function open(e) {
		if (value < 10) {
			e.stopPropagation()
			show_options = true

			// this is a hack so you can't open multiple dropdowns at the same time...
			keep_open = true
			setTimeout(() => { keep_open = false }, 10)
		}
	}

	function change(new_value) {
		if (new_value !== parent_value) {
			value = new_value
			parent_value = new_value
			dispatch(`change`)

			show_options = false // hide the options when you tab away
		}
		setTimeout(() => {
			// When you click an option, the <input>'s on:blur triggers (without a changed value) before the option-on:click triggers
			// So when you click an option, and if this show_options = false was not delayed, then the on:blur causes the options to be hidden, which causes then the option-on:click to never trigger
			show_options = false // hide the options when you tab away
		}, 50)
	}
</script>

<svelte:window on:click="{() => { show_options = keep_open }}" />

<div class="select">
		<!-- bind:this={input} -->
	<input type="number"
		min="1"
		max="{ max === -1 ? `none` : max }"
		class="value"
		bind:this={input}
		bind:value={value}
		class:arrows="{ !show_options && value < 10 }"
		on:click="{open}"
		on:blur="{() => setTimeout(() => change(value), 100)}"
	/>
	<div class="options-container">
		<div class="options" hidden="{ !show_options }">
			{#each max === -1 ? range : range.slice(0, max) as r}
				<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions this is probably not okay, this should be a focusable/keyboard-interactive element -->
				<div class="option" class:current="{r === value}" on:click="{() => change(r)}">{ r }</div>
			{/each}
			<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions this is probably not okay, this should be a focusable/keyboard-interactive element -->
			{#if max > 9 || max === -1}<div class="option" on:click|stopPropagation="{text}">10+</div>{/if}
		</div>
	</div>
</div>



<style>
	.select {
		text-align: left;
		width: 50px;
		border: 1px solid #333;
		border-radius: 3px;
	}

	.select .value {
		color: #ddd;
		width: 100%;
		font-size: 14px;
		padding: 4px 8px;
		line-height: 20px;
		background: #111;
		cursor: pointer;
	}

	.select input.value {
		width: 100%;
		font-size: 16px;
		cursor: auto;
		background: none;
		height: 28px;
		border: 0;
	}
	.select .value:focus-visible {
		outline: 3px solid #fff;
	}

	.select input.value.arrows:not(:focus-visible) {
		background: transparent url('../../img/arrows.png') calc(100% - 6px) center no-repeat;
		background-size: 20%;
	}

	/* Hide up/down arrows in the input[type=number] because they don't play nicely with svelte on:change */
	input[type=number]::-webkit-outer-spin-button,
	input[type=number]::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input[type=number] {
		-moz-appearance: textfield;
		appearance:textfield;
	}

	.options-container {
		position: relative;
	}

	.options-container .options {
		position: absolute;
		box-sizing: border-box;
		top: 0px;
		left: 0px;
		width: 48px;
		background: #222;
		z-index: 1;
		border-radius: 3px;
	}

	.option {
		cursor: pointer;
		line-height: 20px;
		padding: 4px 8px;
		font-variant-numeric: tabular-nums;
	}

	.option.current {
		padding-left: 5px;
		border-left: 3px solid #ceff51;
	}

	.option:hover {
		background: #000;
	}
</style>
